import { useMemo } from "react";
import { PointsByDifficulty } from "shared/games/allTechniqueGameDescriptions";
import { History } from "./DifficultySelector";

interface Props {
  points: PointsByDifficulty;
  pointsWhenCompleted: PointsByDifficulty;
  history?: History;
}

export default function usePoints({
  points,
  pointsWhenCompleted,
  history,
}: Props): PointsByDifficulty {
  return useMemo(() => {
    return {
      easy: history?.easy?.correct ? pointsWhenCompleted.easy : points.easy,
      medium: history?.medium?.correct
        ? pointsWhenCompleted.medium
        : points.medium,
      hard: history?.hard?.correct ? pointsWhenCompleted.hard : points.hard,
    };
  }, [
    history?.easy?.correct,
    history?.hard?.correct,
    history?.medium?.correct,
    points.easy,
    points.hard,
    points.medium,
    pointsWhenCompleted.easy,
    pointsWhenCompleted.hard,
    pointsWhenCompleted.medium,
  ]);
}
